module.exports = __webpack_public_path__ + "img/promotion.6d0c3326.svg";